import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

export function useOldParagraphLink(
  paragraph?: MaybeRefOrGetter<ILegalTextParagraph>
) {
  const pageContext = usePageContext();
  const baseUrl = useBaseUrl();

  const href = computed(() => {
    const url = new URL(baseUrl + pageContext.urlOriginal);
    if (paragraph) {
      url.searchParams.set("oldParagraph", toValue(paragraph).id.toString());
    } else {
      url.searchParams.delete("oldParagraph");
    }
    return url.pathname + url.search;
  });

  return { href };
}
